import { onUnmounted } from "@vue/composition-api";
import { LivechatAccessibility, LivechatSubjectType } from "@scrile/api-provider/dist/api/LivechatsProvider";
import { Subject } from "@scrile/api-provider/dist/api/SubjectProvider";
import providers from "@/lib/api";

export const useSubscribeAccessibilityUpdated = (
  subject: Subject<LivechatSubjectType>,
  onData: (data: LivechatAccessibility) => void
) => {
  let unsubscribe = () => {};
  onUnmounted(() => unsubscribe());
  providers.LivechatsProvider.subscribeAccessibilityUpdated({ subject }, onData).then(
    subscription => (unsubscribe = () => subscription.unsubscribe())
  );
};
